// @deprectated Please use angular router (where possible)
export function getQueryStringParam(key: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}
